import { RevolveFeaturePrototype } from './RevolveFeaturePrototype';

/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/prototype/revolve 目录；
 * 2. 负责封装旋转凸台特征原型；
 * 3. 原型对象承载 featureId、definition、bindings 与设计树元数据。
 */

/**
 * 旋转凸台特征原型。
 */
export class BossRevolveFeaturePrototype extends RevolveFeaturePrototype {}
